<template>
  <van-pull-refresh v-model="isLoading" pulling-text="Tarik ke bawah untuk refresh..."
    loosing-text="Lepaskan untuk refresh..." success-text="Refresh Berhasil" @refresh="onRefresh">
    <div class="loan-status">
      <BaseHeaderBar :showCustomerService="true" :showBackButton="true" />

      <div class="content" @dblclick.prevent>
        <div class="status1" v-if="orderStatus === 1 || orderStatus === 2 || orderStatus === 10">
          <img src="@/assets/img/jisushenhe.png" alt="" />
          <div>Dalam proses peninjauan</div>
          <span>Nominal pencairan dana tergantung pada hasil akhir evaluasi</span>
        </div>
        <div v-else-if="orderStatus === 3" class="status3">
          <img src="@/assets/img/fangkuanzhong.png" alt="" />
          <div>Dalam proses pencairan</div>
          <div class="info">
            <div>
              <p>Jumlah yang diterima</p>
              <p>Rp{{ formatNumberWithCommas(loanInfo.ardrrivalAmount) }}</p>
            </div>
            <div>
              <p>Nama bank penerima</p>
              <p>{{ loanInfo.ardrrivalBank }}</p>
            </div>
            <div>
              <p>Nomor rekening bank penerima</p>
              <p>{{ loanInfo.ardrrivalBankcard }}</p>
            </div>
          </div>
        </div>

        <div v-else-if="orderStatus === 4" class="status4">
          <img src="@/assets/img/zanwufajieqian.png" alt="" />
          <div>Anda tidak dapat melakukan pinjaman saat ini</div>
          <span>
            Untuk saat ini Anda tidak memenuhi persyaratan. Pastikan <br />untuk
            selalu mempertahankan riwayat kredit yang baik.
          </span>
          <!-- <a :href="downloadUrl">
            <img class="AKUKU" :src="daichao1" />
          </a>
          <van-dialog class="tuijian_chanpin" v-model="visible" :showConfirmButton="false" close-on-click-overlay>
            <template #title>
              <p class="tuijian_title">Menyarankan</p>
            </template>
<div class="tuijian_neirong">
  <img :src="tuijianchapin" alt="" />
  <div class="chanpin_name">{{ productName }}</div>
  <div class="youdian">
    <span>Rp 9.000.000</span>
  </div>
  <div class="youdian hari">
    <span>92-180 hari</span>
  </div>
  <div @click="onCloseDialog()">
    <a :href="downloadUrl">
      <button type="button" class="submit-btn OKE">OKE</button>
    </a>
  </div>
</div>
</van-dialog> -->
          <a href="https://apps.apple.com/id/app/uangstar-pinjaman-uang/id6771836834?l=id">
            <img class="AKUKU" src="@/assets/img/daichao1.png" />
          </a>
          <van-dialog class="tuijian_chanpin" v-model="visible" :showConfirmButton="false" close-on-click-overlay>
            <template #title>
              <p class="tuijian_title">Menyarankan</p>
            </template>
            <div class="tuijian_neirong">
              <img src="@/assets/img/tuijianchapin.png" alt="" />
              <div class="chanpin_name">UangStar</div>
              <div class="youdian">
                <span>Rp 9.000.000</span>
              </div>
              <div class="youdian hari">
                <span>92-180 hari</span>
              </div>
              <div @click="onCloseDialog()">
                <a href="https://apps.apple.com/id/app/uangstar-pinjaman-uang/id6771836834?l=id">
                  <button type="button" class="submit-btn OKE">OKE</button>
                </a>
              </div>
            </div>
          </van-dialog>
        </div>

        <div v-else-if="orderStatus === 5" class="status5">
          <div class="xingxing_icon">
            <img src="@/assets/img/xingxing_icon.png" alt="" />
          </div>

          <div class="daihuankuan">
            <div class="tilte">Menunggu Pembayaran</div>
            <div class="huankuanriqi">
              Harap pembayaran sebelum tanggal
              {{ loanInfo.bidrllDetails.redrpaymentTime.substr(0, 2) }} bulan
              {{ loanInfo.bidrllDetails.redrpaymentTime.substr(3, 2) }}
              tahun {{ loanInfo.bidrllDetails.redrpaymentTime.substr(6) }}
            </div>
            <div class="yuqitianshu">
              Sudah terlambat {{ loanInfo.bidrllDetails.ovdrerdueDay }} hari
            </div>
            <span class="info" @click="goRepaymenDetail">Detail Pinjaman</span>
          </div>
          <span class="btn">
            Nominal Pelunasan:Rp{{
              formatNumberWithCommas(
                loanInfo.bidrllDetails.fudrllrepaymentAmount
              )
            }}
          </span>
          <span class="btn">
            Biaya Perpanjangan Durasi:Rp{{
              formatNumberWithCommas(
                loanInfo.bidrllDetails.exdrhibitionrepaymentaAount
              )
            }}
          </span>
          <div class="handleBtn">
            <button type="button" class="confirm-btn" @click="goRepay(2)">
              Perpanjangan
            </button>
            <button type="button" class="confirm-btn" @click="goRepay(1)">
              Pelunasan
            </button>
          </div>
          <Discount :money="loanInfo.didrscountAmount"></Discount>
          <Recommendation v-if="loanInfo.redr_loan == 1" :redrpaymentTime="loanInfo.bidrllDetails.redrpaymentTime"
            :orderStatus="orderStatus"></Recommendation>
        </div>

        <div v-else-if="
          orderStatus === 0 || orderStatus === 6 || orderStatus === 7
        " class="loan-status6">
          <div class="loan-status6_content">
            <div class="amountList">
              <div class="loan-title">
                <p>Nominal Pinjaman</p>
              </div>
              <div class="loan-amount-sort">
                <div ref="loanItem" v-for="(item, index) in loanInfo.mudrltipleLoanList" :key="index"
                  :class="{ active: activeIndex === index }" @click="selectLoan(item, index)">
                  Rp{{ formatNumberWithCommas(item.loanMoney) }}
                </div>
              </div>
            </div>
            <div class="info-block">
              <div v-if="loanTimers && loanTimers.length">
                <template v-if="hasRate">
                  <div class="row">
                    <div>
                      <span>Tenor Pinjaman</span>
                    </div>
                    <span>{{ loanInfo.bidrgDeadate }}</span>
                  </div>
                </template>
                <template v-else>
                  <div class="jiekuanqixian">
                    <div>
                      <span>Tenor Pinjaman</span>
                    </div>
                    <!-- <span>{{ loanTimers[0] }}Hari</span> -->
                    <span>7 Hari</span>
                  </div>
                </template>
              </div>
              <div class="row" v-if="hasRate">
                <div>
                  <span>Suku bunga tahunan</span>
                </div>
                <span>{{ loanInfo.dadryRate }}</span>
              </div>
              <div class="ticket" v-if="orderStatus === 6 || orderStatus === 7">
                <span>{{
                  loanInfo.mudrltipleLoanList[activeIndex].discountAmount
                }}</span>
              </div>
            </div>

            <button type="button" class="submit" @click="submit">
              Segera Pengajuan
            </button>
          </div>
          <!-- 浏览器打开引导用户添加到主屏幕 -->
          <addtohomescreen v-if="orderStatus === 6"></addtohomescreen>
          <Recommendation :orderStatus="orderStatus"></Recommendation>

          <van-dialog v-model="visible" :showConfirmButton="false" close-on-click-overlay class="no-loan-dialog">
            <div class="dialog_body">
              <span class="dialog_title">Tingkatkan Nominal</span>
              <h3 class="tip-title">Bagaimana cara menaikkan limit pinjaman</h3>
              <p class="tip">
                Mempertahankan kebiasaan baik dan selalu melunasi tepat waktu.
                Anda bisa mendapatkan kenaikan limit apabila menghindari
                perilaku keterlambatan pembayaran.
              </p>
              <button type="button" class="confirm-btn" @click="onCloseDialog()">
                Mengerti
              </button>
            </div>
          </van-dialog>
        </div>

        <div v-else-if="orderStatus === 8" class="status8">
          <img src="@/assets/img/renzhengshibai.png" alt="" />

          <div>Verifikasi KTP gagal</div>
          <span>
            Foto KTP yang Anda unggah tidak jelas, sehingga tidak dapat lolos
            evaluasi. Silakan unggah ulang.
          </span>
          <button type="button" class="modify-btn" @click="goAuthentication">
            Edit data
          </button>
        </div>

        <div v-else-if="orderStatus === 9" class="status9">
          <img src="@/assets/img/zanwufajieqian.png" alt="" />
          <div>Pencairan gagal</div>
          <span>
            Pencairan tidak dapat dilakukan karena data rekening <br />
            bank Anda tidak tersedia. Silakan isi ulang.
          </span>
          <button type="button" class="modify-btn" @click="goBankInfo">
            Edit data
          </button>
          <van-dialog v-model="cancelLoanVisible" :showConfirmButton="false" close-on-click-overlay>
            <p class="cancel-loan-dialog-title">Berhasil dibatalkan</p>
            <p class="tip">
              Pinjaman Anda telah dibatalkan. Anda tidak perlu verifikasi data
              lagi jika ingin melakukan pinjaman.
            </p>
            <button type="button" class="confirm-btn" @click="onCloseDialog('cancelLoanVisible')">
              Mengerti
            </button>
          </van-dialog>
        </div>

        <div v-else-if="orderStatus === 12" class="loan-status12">
          <div class="img">
            <img src="@/assets/img/xingxing_icon.png" alt="" />
          </div>
          <div class="jiekuanjine">
            <span>Jumlah pinjaman</span>
            <span> Rp{{ formatNumberWithCommas(loanInfo.lodranAmount) }}</span>
          </div>

          <div class="jiekuanqixian">
            <span>Lama Pinjaman</span>
            <span>{{ loanInfo.avdrailablePeriod[0] }} Hari</span>
          </div>

          <button type="button" class="withdraw-btn" @click="withdraw">
            Segera Tarik
          </button>
        </div>
        <van-dialog v-model="feeVisible" :showConfirmButton="false" close-on-click-overlay>
          <div class="fee-detail">
            <p class="fee-title">Rincian Biaya</p>
            <div>
              <p>Nominal Pinjaman</p>
              <p>Rp{{ formatNumberWithCommas(feeDetail.lodranCash) }}</p>
            </div>
            <div>
              <p>Jumlah Hari Pinjaman</p>
              <!-- <p>{{ feeDetail.lodranTimes }} Hari</p> -->
              <p>7 Hari</p>

            </div>
            <div class="interest">
              <p>Total Bunga</p>
              <p>
                <span>{{ feeDetail.ordriginalAmount }}</span>
                <span>Rp{{ formatNumberWithCommas(feeDetail.todrtalCost) }}</span>
              </p>
              <div class="describe">
                Voucher pengurangan bunga telah otomatis digunakan (peningkatan
                jumlah pinjaman) {{ feeDetail.didrscountAmount }}
              </div>
            </div>
            <div>
              <p>Jumlah yang diterima</p>
              <p>Rp{{ formatNumberWithCommas(feeDetail.ardrrivalCash) }}</p>
            </div>
            <div class="footer-btn">
              <button type="button" class="cancel-btn" @click="onCloseDialog('feeVisible')">
                Batal
              </button>
              <button type="button" class="ok-btn" @click="onOkFee">
                Konfirmasi
              </button>
            </div>
          </div>
        </van-dialog>
        <orderErrDialog :unpaidVisible="unpaidVisible" :unpaidProductList="unpaidProductList"
          :loanFailedMsg="loanFailedMsg" :closeDialog="() => {
            unpaidVisible = false
          }">
        </orderErrDialog>
      </div>
    </div>
    <template #loading>
      <span></span>
    </template>
  </van-pull-refresh>
</template>

<script>
import Vue from 'vue'
import { Dialog, Toast, PullRefresh, Overlay } from 'vant'

import request from '@/utils/request'
import dialogVisible from '@/mixins/dialogVisible'
import { getMetadata } from '@/utils/getEquipmentInfo.js'
import Discount from '@/components/discount.vue'
import Recommendation from '@/components/Recommendation.vue'
import trafficConfig from '@/mixins/trafficConfig'
import addtohomescreen from '@/components/addtohomescreen.vue'
import orderErrDialog from '@/components/orderErrDialog.vue'

Vue.use(Toast)
Vue.use(PullRefresh)
Vue.use(Overlay)

export default {
  name: 'Home',
  mixins: [dialogVisible, trafficConfig],
  components: {
    [Dialog.Component.name]: Dialog.Component,
    Discount,
    Recommendation,
    addtohomescreen,
    orderErrDialog
  },
  data () {
    return {
      isLoading: false,
      cancelLoanVisible: false,
      feeVisible: false,
      orderStatus: '',
      loanInfo: {},
      feeDetail: {},
      activeIndex: -1,
      loanTimers: [],
      loanAmount: '',
      hasRate: false,
      // 查询到未还款弹框
      unpaidVisible: false,
      unpaidProductList: [],
      loanFailedMsg: ''

    }
  },
  created () {
    this.getOrderStatus()
  },
  methods: {
    getOrderStatus (isRefresh) {
      request.post('homeDRInterface')
        .then(res => {
          this.orderStatus = res.ordrderStatus
          this.loanInfo = res
          // this.orderStatus = 4
          // this.loanInfo = {
          //   bidrllDetails: {
          //     redrpaymentTime: ''
          //   }
          // }
          this.hasRate = res.ordrderStatus === 0 || (res.ordrderStatus === 7 && res.redr_loan === 0)
          if (this.orderStatus === 4) {
            if (!localStorage.getItem('tuijian_product')) {
              this.visible = true
            }
            localStorage.setItem('tuijian_product', true)
          }
          if (this.orderStatus === 5) {
            // 埋点 只在首贷触发
            if (res.redr_loan === 0) {
              if (localStorage.getItem('iodfaTriggered')) return
              if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.iodfa) {
                window.webkit.messageHandlers.iodfa.postMessage('')
                localStorage.setItem('iodfaTriggered', true)
              }
            }
          }
          if (res.ordrderStatus === 12) {
            this.loanAmount = String(res.lodranMaxAmount)
          }
          if (res.ordrderStatus === 0 || res.ordrderStatus === 6 || res.ordrderStatus === 7) {
            this.loanAmount = String(res.lodranMaxAmount)
            let index = -1
            localStorage.removeItem('showTicket')
            if (res.ordrderStatus === 6 || (res.ordrderStatus === 7 && res.redr_loan === 1)) {
              // 过滤掉不可借金额
              // this.loanInfo.mudrltipleLoanList = res.mudrltipleLoanList.filter((item) => {
              //   return item.loanStatus
              // })
            }
            res.mudrltipleLoanList.forEach((item, i) => {
              if (item.loanStatus) {
                index = i
              }
            })
            if (index > -1) {
              this.activeIndex = index
              this.selectedLoanItem = res.mudrltipleLoanList[index]
              this.loanAmount = String(this.selectedLoanItem.loanMoney)
              this.loanTimers = this.initLoanTimers = this.selectedLoanItem.loanTimers || []
            }
          }
          isRefresh && (this.isLoading = false)
        })
    },
    getFeeDetail (item, loanType) {
      const postData = {
        lodranCash: item.loanMoney,
        lodranTimers: item.loanTimers[0],
        lodranType: loanType
      }
      this.withdrawType = loanType
      request.post('indrterestrateBomb', postData)
        .then(res => {
          this.feeDetail = res
        })
    },
    goRepaymenDetail () {
      this.$router.push('/repaymenDetail')
    },
    goBankInfo () {
      if (this.loanInfo.badrnkStatus) {
        const postData = {
          apdrplicationAmount: this.loanInfo.lodranAmount,
          prdromotionChannel: 'AppStore',
          portraitAdd: 1
        }
        // 获取设备信息
        getMetadata()
          .then(res => {
            // 提交设备信息
            return request.post('deviceInformation', res)
          })
          .then(() => {
            // 提交订单
            return request.post('sudrbmitloanOrder', postData)
          })
          .then(() => {
            this.getOrderStatus()
          }).catch(err => {
            this.isOrderValid(err)
          })
      } else {
        this.goAuthentication()
      }
    },
    goRepay (repayType) {
      const { ordrderID, padrymentID, fudrllrepaymentAmount, exdrhibitionrepaymentaAount } = this.loanInfo.bidrllDetails
      this.$router.push({
        path: '/repay',
        query: {
          repayType,
          amount: repayType === 1 ? fudrllrepaymentAmount : exdrhibitionrepaymentaAount,
          orderId: ordrderID,
          payID: padrymentID
        }
      })
    },
    selectLoan (item, index) {
      const loanStatus = item.loanStatus
      if (loanStatus) {
        if (index !== this.activeIndex) {
          this.activeIndex = index
          this.selectedLoanItem = item
          this.loanAmount = String(item.loanMoney)
          this.loanTimers = item.loanTimers
        }
      } else {
        this.visible = true
      }
    },
    submit () {
      if (this.selectedLoanItem) {
        if (this.orderStatus === 0 || (this.orderStatus === 7 && this.loanInfo.redr_loan === 0)) {
          this.$router.push({
            path: '/authentication',
            query: {
              amount: this.selectedLoanItem.loanMoney
            }
          })
        } else if (this.orderStatus === 6 || (this.orderStatus === 7 && this.loanInfo.redr_loan === 1)) {
          const postData = {
            lodranAmount: this.selectedLoanItem.loanMoney,
            lodranPeriod: this.selectedLoanItem.loanTimers[0],
            widrthdrawType: 2
          }
          request.post('widrthdrawCash', postData)
            .then(() => {
              this.getFeeDetail(this.selectedLoanItem, 2)
              this.feeVisible = true
            }).catch((err) => {
              this.isOrderValid(err)
            })
            .finally(() => {
              this.flag = false
            })
        }
      } else {
        Toast('Silahkan pilih pinjaman terlebih dahulu')
      }
    },
    onOkFee () {
      if (this.flag) return
      this.flag = true
      const { lodranCash, lodranTimes } = this.feeDetail
      const postData = {
        lodranAmount: lodranCash,
        lodranPeriod: lodranTimes,
        widrthdrawType: this.withdrawType
      }
      request.post('widrthdrawCash', postData)
        .then(() => {
          this.orderStatus = 1
        })
        .finally(() => {
          this.feeVisible = false
          this.flag = false
        })
    },
    goAuthentication () {
      this.$router.push({
        path: '/authentication',
        query: {
          amount: this.loanInfo.lodranAmount
        }
      })
    },
    withdraw () {
      const postData = {
        loanMoney: this.loanInfo.lodranAmount,
        loanTimers: this.loanInfo.avdrailablePeriod
      }
      this.getFeeDetail(postData, 1)
      this.feeVisible = true
    },
    onRefresh () {
      this.getOrderStatus(true)
    },
    // 判断是否可以提交订单
    isOrderValid (err = {}) {
      console.log(err)
      if (err.code === 701) {
        this.unpaidProductList = err.data
        this.unpaidVisible = true
        this.loanFailedMsg = 'Pengajuan pinjaman Anda sudah melebihi batas. Harap melunasi salah satu pinjaman berikut terlebih dahulu sebelum bisa mengajukan pinjaman baru, terima kasih!'
      }
      if (err.code === 702) {
        this.unpaidVisible = true
        this.loanFailedMsg = 'Hari ini Anda sudah mengajukan pinjaman di beberapa platform, limit kredit Anda sudah habis. Silahkan ajukan kembali di lain hari, terima kasih!'
      }
    }

  }
}
</script>

<style scoped lang="less">
.intro {
  padding-top: 437px;
  line-height: 42px;
  font-size: 30px;
  color: #302c48;
  text-align: center;
}

.content {
  position: relative;
  z-index: 2;
  border-radius: 30px 30px 0px 0px;
}

.loan-title {
  display: flex;
  justify-content: center;

  p {
    width: 300px;
    height: 84px;
    line-height: 84px;
    border-radius: 42px;
    font-weight: bold;
    font-size: 32px;
    color: #000000;
    text-align: center;
    margin: 30px 0;
    background: #ffffff;
    box-shadow: 2px 8px 0px 0px #000000;
    border-radius: 42px;
    border: 2px solid #000000;
  }
}

.loan-amount {
  display: flex;
  justify-content: center;
  margin-top: 23px;

  &>div {
    width: 50px;
    height: 71px;
    line-height: 71px;
    border-radius: 6px;
    font-size: 42px;
    color: #fd411c;
    text-align: center;
    background-color: #fff;

    &:nth-child(n + 2) {
      margin-left: 12px;
    }
  }
}

.time {
  .circle {
    display: flex;
    justify-content: center;

    &>div {
      width: 48px;
      height: 48px;
      border: 1px solid #dadada;
      border-radius: 50%;
      margin-top: 22px;

      &:nth-child(n + 2) {
        margin-left: 19px;
      }

      &.active {
        width: 67px;
        height: 67px;
        line-height: 67px;
        border: 2px solid #fd411c;
        margin-top: 12px;
        font-size: 32px;
        color: #fd411c;
        text-align: center;
      }
    }
  }

  .unit {
    line-height: 33px;
    margin-top: 9px;
    font-size: 24px;
    color: #fd411c;
    text-align: center;
  }
}

.loan-amount-sort {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  margin-bottom: 32px;
  padding: 15px;

  div {
    position: relative;
    text-align: center;
    line-height: 100px;
    margin-bottom: 15px;

    width: 200px;
    height: 100px;
    background: #ffffff;
    box-shadow: 1px 8px 0px 0px #000000;
    border-radius: 10px;
    border: 2px solid #000000;
    font-weight: 500;
    font-size: 30px;
    color: #333333;

    &.active {
      background: #87dfff;
      border-color: #4bc4b3;
      font-weight: bold;
      color: #000000;
    }

    img {
      position: absolute;
      right: 0;
      bottom: 0;
      width: 35px;
      height: 29px;
    }
  }
}

.loan-status {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: @body-bg-color;
}

.status1,
.status3,
.status4,
.status8,
.status9 {
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 0 20px;

  img {
    margin-top: 90px;
    margin-bottom: 84px;
    width: 454px;
    height: 367px;
    text-align: center;
  }

  div {
    font-size: 34px;
    font-weight: bold;
    color: #000000;
    margin-bottom: 38px;
    text-align: center;
  }

  span {
    font-size: 30px;
    font-weight: 500;
    color: #000;
    text-align: center;
  }

  .modify-btn {
    .submit-btn;
    width: 670px;
    margin-top: 101px;
  }

  .info {
    width: 100%;

    div {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 30px;
      height: 94px;
      background: #ffffff;
      box-shadow: 1px 8px 0px 0px #000000;
      border-radius: 47px;
      border: 2px solid #000000;

      p {
        font-weight: bold;
        font-size: 30px;
        color: #000000;
      }
    }
  }
}

.status3 {
  img {
    width: 437px;
    height: 341px;
  }
}

.status4 {
  .AKUKU {
    box-sizing: border-box;
    width: 100%;
    padding: 0 30px;
    margin-bottom: 20px;
  }

  .tuijian_chanpin {
    width: 570px;
    border-radius: 20px;
    margin-bottom: 0;

    .tuijian_title {
      margin-top: 40px;
      font-weight: bold;
      font-size: 38px;
    }

    .tuijian_neirong {
      display: flex;
      align-items: center;
      flex-direction: column;
      margin-bottom: 0;

      img {
        width: 150px;
        height: 150px;
        margin-top: 20px;
        margin-bottom: 20px;
      }

      .chanpin_name {
        font-size: 26px;
        margin-bottom: 30px;
        font-weight: bold;
      }

      .youdian {
        margin-bottom: 20px;
        font-size: 26px;
        font-weight: 600;

        span {
          color: red;
          font-size: 50px;
        }
      }

      .hari {
        span {
          font-size: 30px;
        }
      }

      .OKE {
        width: 300px;
        margin: 50px;

        a {
          color: #fff;
        }
      }
    }
  }
}

.status5 {
  margin: 0 40px;

  .xingxing_icon {
    margin-top: 40px;
    display: flex;
    justify-content: center;

    img {
      width: 330px;
      height: 315px;
    }
  }

  .daihuankuan {
    position: relative;
    background: url("../assets/img/huankuan_bg.png") no-repeat;
    background-size: 100% 100%;
    padding-top: 30px;
    padding-left: 40px;
    padding-right: 30px;
    padding-bottom: 30px;
    margin: 50px 0;

    .tilte {
      margin-bottom: 22px;
      font-size: 34px;
      font-weight: 600;
      color: #000;
    }

    .huankuanriqi {
      margin-bottom: 25px;
      font-size: 28px;
      font-weight: 600;
      color: #000;
    }

    .yuqitianshu {
      font-size: 28px;
      font-weight: 400;
      color: #000;
    }

    .info {
      min-width: 126px;
      padding: 0 15px;
      height: 59px;
      background: #fda361;
      border-radius: 30px;
      font-size: 26px;
      font-weight: 500;
      color: #000;
      position: absolute;
      right: 15px;
      top: 15px;
      text-align: center;
      line-height: 59px;
    }
  }

  .btn {
    display: block;
    text-align: center;
    font-weight: 600;
    font-size: 27px;
    color: #000000;
    line-height: 94px;
    margin-bottom: 20px;
    height: 94px;
    background: #ffffff;
    box-shadow: 1px 8px 0px 0px #000000;
    border-radius: 47px;
    border: 2px solid #000000;
  }

  .handleBtn {
    margin-top: 120px;
    padding-bottom: 40px;

    .confirm-btn {
      .submit-btn;
    }

    .confirm-btn:last-child {
      margin-top: 30px;
      .cancel-btn;
    }
  }
}

.loan-status6 {
  margin: 0 34px;
  margin-top: 10px;
  padding-bottom: 200px;

  .amountList {
    background: #ffd050;
    box-shadow: 2px 8px 0px 0px #000000;
    border-radius: 40px;
    border: 2px solid #000000;
    margin-bottom: 60px;
  }

  .page {
    display: flex;
    justify-content: center;
    margin-top: 22px;

    &>div {
      width: 28px;
      height: 14px;
      border-radius: 5px;

      &:nth-child(n + 2) {
        margin-left: 16px;
      }

      &.active {
        width: 55px;
      }
    }
  }

  .info-block {
    margin-bottom: 200px;

    .row {
      height: 148px;
      background: #fff4e9;
      display: flex;
      justify-content: space-evenly;
      flex-direction: column;
      padding: 0 40px;
      margin-bottom: 40px;

      div {
        display: flex;
        align-items: center;

        span {
          font-size: 30px;
          font-weight: 400;
          color: #333333;
        }
      }

      span {
        font-size: 36px;
        font-weight: 600;
        color: #333333;
      }
    }

    .jiekuanqixian {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 30px;
      height: 94px;
      margin-top: 30px;
      background: #ffffff;
      box-shadow: 2px 8px 0px 0px #000000;
      border-radius: 47px;
      border: 2px solid #000000;

      div {
        display: flex;
        align-items: center;
        font-weight: bold;
        font-size: 30px;
        color: #000000;
      }

      span {
        font-weight: bold;
        font-size: 32px;
        color: #000000;
      }
    }

    .ticket {
      position: relative;
      height: 188px;
      background: url("~@/assets/img/ticket.png") no-repeat;
      background-size: contain;
      margin-top: 38px;

      span {
        position: absolute;
        left: 185px;
        top: 50px;
        font-size: 42px;
        color: #fff;
        font-weight: 700;
      }
    }
  }

  .submit {
    .submit-btn;
    width: 650px;
    position: fixed;
    left: 50%;
    bottom: 150px;
    transform: translateX(-50%);
  }

  .no-loan-dialog {
    width: 564px;
    margin-left: auto;
    margin-right: auto;

    .dialog_body {
      padding: 0 20px;
    }

    .dialog_title {
      display: block;
      font-size: 38px;
      text-align: center;
      margin-top: 40px;
      margin-bottom: 50px;
      font-weight: bold;
      color: #000000;
    }
  }

  .tip-title {
    margin-bottom: 46px;
    font-size: 30px;
    font-weight: 600;
    text-align: center;
    color: #000000;
  }

  .tip {
    text-align: center;
    font-size: 28px;
    font-weight: 500;
    color: #000000;
    line-height: 40px;
  }

  .confirm-btn {
    .submit-btn;
    width: 100%;
    margin-top: 50px;
    margin-bottom: 50px;
  }
}

.loan-status12 {
  padding: 0 40px;
  padding-top: 70px;

  .img {
    display: flex;
    justify-content: center;

    img {
      width: 298px;
      height: 257px;
    }
  }

  .jiekuanjine,
  .jiekuanqixian {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 30px;
    height: 94px;
    background: #ffffff;
    box-shadow: 2px 8px 0px 0px #000000;
    border-radius: 47px;
    border: 2px solid #000000;
    margin-bottom: 40px;
    font-weight: bold;
    font-size: 32px;
    color: #000000;
  }

  .jiekuanjine {
    margin-top: 60px;
  }

  .withdraw-btn {
    .submit-btn;
    width: 670px;
    margin-top: 100px;
    margin-bottom: 98px;
  }
}

.fee-title {
  text-align: center;
  font-weight: bold;
  font-size: 60px;
  color: #000000;
  margin-top: 40px;
  margin-bottom: 50px;
}

.fee-detail {
  padding: 20px 30px;
  margin: 0 auto;

  &>div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 50px;
    padding-left: 24px;
    padding-right: 24px;
    font-weight: 500;

    p {
      font-weight: bold;
      font-size: 30px;
      color: #000000;
    }

    p:nth-child(even) {
      font-weight: bold;
    }
  }

  .interest {
    position: relative;
    padding-bottom: 60px;

    span:nth-child(1) {
      font-weight: 500;
      text-decoration: line-through;
      font-size: 26px;
      margin-right: 10px;
    }

    div {
      position: absolute;
      bottom: -28px;
    }
  }

  .describe {
    margin-bottom: -5px;
    font-size: 26px;
    color: #ff8300;
    line-height: 28px;
  }
}

.footer-btn {
  display: flex;
  justify-content: space-evenly;
  margin-bottom: 45px;

  button {
    flex: 1;
    height: 88px;
    line-height: 88px;
    font-size: 30px;
    color: #fff;
    border-radius: 8px;
  }

  .cancel-btn {
    .cancel-btn;
    width: 281px;
    margin-right: 10px;
  }

  .ok-btn {
    .submit-btn;
    width: 281px;
    margin-left: 10px;
  }
}
</style>
